module.exports = __webpack_public_path__ + "static/media/whyTwo.21288711.png";